import React, { useEffect, useState } from 'react';
import { arrayOf, shape, string, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { Card } from '@cards/Card';
import ControlledDocumentModal from '@components/ControlledDocumentModal';
import { FormPreviewModalById } from '@components/FormPreviewModal';
import './style.less';

function ViewControlledDocuments({ controlledDocuments, title, loading }) {
  const { t } = useTranslation();
  const [controlledDocumentModalData, setControlledDocumentModalData] = useState(false);
  const [consentFormRef, setConsentFormRef] = useState(null);
  const [consentModalVisible, setConsentModalVisible] = useState(false);

  useEffect(() => {
    for (const cd of controlledDocuments) {
      console.log(cd.latest_version.version_content);
      if (cd.latest_version.version_content.data.consent_form) {
        const parts = cd.latest_version.version_content.data.consent_form.ref.split('/');
        let formID = parts[parts.length - 1];
        if (parts.length === 4) {
          formID = parts[parts.length - 2];
        }
        console.log(formID);
        setConsentFormRef(formID);
        // setConsentFormRef(cd.latest_version.version_content.data.consent_form.ref);
      }
    }
  }, [controlledDocuments]);

  return (
    <>
      <Card className="view-controlled-documents-card" title={title} loading={loading}>
        {controlledDocuments.map(controlledDocument => (
          <>
            <Button
              block
              key={controlledDocument.latest_version.id}
              size="large"
              onClick={() =>
                setControlledDocumentModalData({
                  title: controlledDocument.latest_version.version_content.display_name,
                  url: controlledDocument.latest_version.version_content.data.url,
                })
              }
            >
              {t('cards:ViewControlledDocuments.read', {
                documentName: controlledDocument.latest_version.version_content.display_name,
              })}
            </Button>
            {consentFormRef ? (
              <Button
                block
                key={controlledDocument.latest_version.id + '-consent'}
                size="large"
                onClick={() => {
                  setConsentModalVisible(true);
                }}
              >
                {t('cards:DeclarationOfConsent.read')}
              </Button>
            ) : null}
          </>
        ))}
      </Card>
      {controlledDocumentModalData ? (
        <ControlledDocumentModal
          title={controlledDocumentModalData.title}
          url={controlledDocumentModalData.url}
          visible={true}
          onClose={() => setControlledDocumentModalData(false)}
        />
      ) : null}
      <FormPreviewModalById
        hideCloseFooter={true}
        formId={consentFormRef}
        name={t('cards:DeclarationOfConsent.modalTitle')}
        visible={consentModalVisible}
        handleCloseModal={() => {
          setConsentModalVisible(false);
        }}
      >
        <></>
      </FormPreviewModalById>
    </>
  );
}

ViewControlledDocuments.propTypes = {
  controlledDocuments: arrayOf(shape({})),
  title: string.isRequired,
  loading: bool,
};

ViewControlledDocuments.defaultProps = {
  controlledDocuments: [],
  loading: false,
};

export default ViewControlledDocuments;
